const validateTO2 = (rule,value,callback) =>{
  if(value>=10000000){
    callback(new Error('请输入10,000,000.00以内的数字！'));
  }else{
    callback();
  }

};
const validateTO3 = (rule,value,callback) =>{
  if(value>=10000){
    callback(new Error('请输入10,000以内的整数！'));
  }else{
    callback();
  }
};

export function omitNumber(e){
    let value = e;
    value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
    console.log(value)
    value = value.replace(/\.{1,}/g, ""); //只保留第一个. 清除多余的
    console.log(value)
    value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    console.log(value)
    value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    console.log(value)
    if (value.indexOf(".") < 0 && value != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
    }
    if(value=='.'){
      value = '0.'
    }
    return value;
}
export function omitNumber2(e){
  let value = e;
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{1,}/g, "."); //只保留第一个. 清除多余的
  value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  if(value=='.'){
    value = '0.'
  }
  return value;
}
export const endOption = {
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: false,
      submitText: '保存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'right',
      detail: false,
      tabs: false,
      column: [
        {
            type: 'input',
            label: '耗材',
            span: 24,
            display: true,
            formslot:true,
            prop: 'consumables',
          },
        {
          type: 'select',
          label: '设备设施',
          span: 12,
          dicData:[],
          display: true,
          // props:{
          //   label:'namePhone',
          //   value:"id"
          // },
          props:{
            label:'name',
            value:"id"
          },
          prop: 'deviceId',

        },

        {
          type: 'number',
          label: '服务工时',
          span: 12,
          display: true,
          prop: 'workTime',
          // rules:[
          //   { type: 'string',trigger: 'change', validator:validateTO3},
          // ],
          formslot:true,
          controls: true,
          value:'0',
        },
        {
            type: 'textarea',
            label: '服务项目',
            span: 24,
            display: true,
            formslot:true,
            prop: 'project',
          },
          {
            type: 'input',
            label: '服务得分',
            span: 12,
            value:0,
            disabled:true,
            display: true,
            prop: 'totalScore',
          },
          {

            label: '合同信息',
            span: 12,
            display: true,
            formslot:true,

            prop: 'contractId',

          },
        {
            type: 'textarea',
            label: '备注',
            span: 24,
            display: true,
            formslot:true,

            prop: 'remark',
            rules: [

              { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
            ]
          },
        {
          type: 'upload',
          label: '附件',
          span: 24,
          display: true,
          showFileList: true,
          multiple: true,
          limit: 10,
          dataType:'array',
          propsHttp: {},
          canvasOption: {},
          prop: 'attachList',
          formslot:true,
          drag: true,

        }

      ],
    }

export const consumablesOption = {
  "dialogType": "dialog",
  "dialogEscape": "true",
  "dialogModal": "true",
  "dialogCloseBtn": "true",
  dialogWidth:"50%",
    menuAlign:"center",
    columnBtn: "false",
    emptyBtn:false,
    refreshBtn:false,
    border:true,
    align:"center",
    "column": [
      {
        "label": "名称",
        "prop": "consumableId",
        dicData:[],
        filterable: true,
        rules: [
          {
            required: true,
            message: '请选择耗材',
            trigger:'blur'
          },
          // { type: 'string',trigger: 'change', validator:validateTO2},

        ],
        props:{
          label:"name",
          value:'id'
        },
        "type": "select"
      },
      {
        "label": "规格",
        "prop": "size",
        disabled:true,
        addDisplay:false,
        editDisplay:false,

        "type": "input"
      },
      {
        "label": "数量",
        "prop": "consumeNum",
        "type": "number",
        formslot:true,
        rules: [
          {
            required: true,
            message: '请输入数量',
            trigger:'blur'
          },
          // { type: 'string',trigger: 'change', validator:validateTO2},

        ]

      },
      {
        "label": "单价",
        "prop": "price",
        "type": "number",
        formslot:true,
        hide:true,
        rules: [
          {
            required: true,
            message: '请输入单价',
            trigger:'blur'
          },
          // { type: 'string',trigger: 'change', validator:validateTO2},

        ]

      },
      {
        "label": "金钱(元)",
        "prop": "money",
        disabled:true,
        addDisplay:false,
        editDisplay:false,
        "type": "input"
      }
    ]

}